import moment from "moment";
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { Table, Button } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { serverInfo } from "../../../../../../../App";

const MarketPlaceOrderlist = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const history = useHistory();
  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    setLoading(true);
    axios
      .get(`/api/admin/marketplace/order/product-list`)
      .then((res) => {
        if (res.data.status === 200) {
          setOrderList(res.data.orderList);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    // Reset pagination whenever the dataset changes.
    setCurrentPage(1);
  }, [orderList]);

  const handleClick = () => {
    history.push("/superstar-admin/marketplace");
  };

  const totalPages = Math.max(Math.ceil(orderList.length / pageSize), 1);
  const startIndex = (currentPage - 1) * pageSize;
  const currentOrders = orderList.slice(startIndex, startIndex + pageSize);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          {" "}
          <h2 className="text-white">Marketpalce Order List</h2>
        </div>
        <div>
          <button
            onClick={handleClick}
            className="btn Cri-btn-x float-end border-warning fw-bold mb-2"
          >
            Back{" "}
          </button>
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table striped bordered hover variant="dark">
          <thead>
            <tr>
              <th>#</th>
              <th>User Name</th>
              <th>Order No</th>
              <th>Image</th>
              <th>Items</th>
              <th>Unit Price</th>
              <th>Total Price</th>
              <th>Order Date</th>
              <th>Order Status</th>
              <th>Payment Status</th>
              <th style={{ width: "9%" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="11" className="text-center py-4">
                  <div className="spinner-border text-warning" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : currentOrders.length === 0 ? (
              <tr>
                <td colSpan="11" className="text-center py-3">
                  No orders found.
                </td>
              </tr>
            ) : (
              currentOrders.map((order, index) => (
                <tr key={order.id}>
                  <td>{startIndex + index + 1}</td>
                  <td>
                    {order.user.first_name} {order.user.last_name}
                  </td>
                  <td>#{order.order_no}</td>
                  <td>
                    <img
                      src={imageCdnUrl + order.marketplace?.image}
                      alt=""
                      className="img-fluid"
                      style={{
                        height: "50px",
                        border: "3px solid #fcc106",
                        borderRadius: "10px",
                      }}
                    />
                  </td>
                  <td>{order.items}</td>
                  <td>${order.unit_price}</td>
                  <td>${order.total_price}</td>
                  <td>
                    {order.created_at
                      ? moment(order.created_at).format(
                          "DD MMMM, YYYY - hh:mm A"
                        )
                      : "-"}
                  </td>
                  <td>
                    {order.status === 1 ? (
                      <span className="badge badgeDanger">Ordered</span>
                    ) : order.status === 2 ? (
                      <span className="badge badgeInfo">Received</span>
                    ) : order.status === 3 ? (
                      <span className="badge badgeSuccess">
                        Out for Delivery
                      </span>
                    ) : order.status === 4 ? (
                      <span className="badge badgeSuccess">Delivered</span>
                    ) : (
                      <span className="badge badgeWarning">Pending</span>
                    )}
                  </td>
                  <td>
                    {order.payment_status == 1 ? (
                      <span className="badge badgeSuccess">Paid</span>
                    ) : (
                      <span className="badge bg-danger">
                        Unpaid {order.payment_status}
                      </span>
                    )}
                  </td>
                  <td style={{ display: "flex" }}>
                    <Link
                      to={`/superstar-admin/marketplace-orderlist-view/${order.id}`}
                    >
                      <Button
                        className="btn btn-sm"
                        style={{ float: "left" }}
                        title="View Order"
                      >
                        <i className="fas fa-eye"></i>
                      </Button>
                    </Link>
                    <Link
                      to={`/superstar-admin/marketplace-orderlist-invoice/${order.id}`}
                    >
                      <Button
                        style={{ float: "left" }}
                        className="btn btn-sm bg-dark mx-1"
                        title="Invoice Download"
                      >
                        <i className="fas fa-download"></i>
                      </Button>
                    </Link>

                    <Link
                      to={`/superstar-admin/marketplace-orderlist-invoice-bng/${order.id}`}
                    >
                      <Button
                        style={{ float: "left" }}
                        className="btn btn-sm bg-dark mx-1"
                        title="Invoice Download"
                      >
                        <i className="fas fa-download"></i>
                      </Button>
                    </Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
        {!loading && orderList.length > 0 && (
          <div className="d-flex justify-content-between align-items-center text-white mt-3">
            <div>
              Showing {startIndex + 1}-
              {Math.min(startIndex + pageSize, orderList.length)} of{" "}
              {orderList.length}
            </div>
            <div className="d-flex align-items-center">
              <Button
                variant="outline-warning"
                size="sm"
                className="me-2"
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                Previous
              </Button>
              <span className="mx-2">
                Page {currentPage} of {totalPages}
              </span>
              <Button
                variant="outline-warning"
                size="sm"
                className="ms-2"
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Next
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MarketPlaceOrderlist;
